import Vue from 'vue'

/**
 * 时间过滤器
 * 返回还剩多少天
 */
Vue.filter('timeFilter', time => {
  const endTime = new Date(time)
  const nowTime = new Date()
  let leftSecond = Math.floor((endTime.getTime() - nowTime.getTime()) / 1000)

  if (leftSecond < 0) {
    leftSecond = 0
  }

  const d = Math.floor(leftSecond / 3600 / 24)
  const h = Math.floor((leftSecond / 3600) % 24)

  if (d <= 1) {
    return `${h}小时`
  }

  return `${d}天`
})
